exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ReflectionTextarea-module__wrapper___2fRS1 span{display:grid;color:#b4bac3;margin-bottom:.25rem!important}.ReflectionTextarea-module__wrapper___2fRS1 p,.ReflectionTextarea-module__wrapper___2fRS1 span{font-size:14px}.ReflectionTextarea-module__wrapper___2fRS1.ReflectionTextarea-module__with-save___14F8U textarea:focus,.ReflectionTextarea-module__wrapper___2fRS1.ReflectionTextarea-module__with-save___14F8U textarea:hover{background-color:#ececec}", ""]);

// exports
exports.locals = {
	"wrapper": "ReflectionTextarea-module__wrapper___2fRS1",
	"with-save": "ReflectionTextarea-module__with-save___14F8U"
};